import React from 'react';
import Markdown from 'markdown-to-jsx';

const Text = ({ children }) => <>{children}</>;
const Nothing = () => null;
const Strong = ({ children }) => (
  <p className="m-0 font-semibold">{children}</p>
);

/**
 * KD-3848 — the Markdown of an answer: bold, lists, short tables. The model
 * reads DMC-written text, so a link or image in an answer could come from a
 * DMC: links render as their text, images not at all, raw HTML as text. Any
 * picture or link the assistant shows must come from Koob's own data.
 */
const OPTIONS = {
  forceBlock: true,
  disableParsingRawHTML: true,
  overrides: {
    a: { component: Text },
    img: { component: Nothing },
    h1: { component: Strong },
    h2: { component: Strong },
    h3: { component: Strong },
    h4: { component: Strong },
    h5: { component: Strong },
    h6: { component: Strong },
    table: {
      component: ({ children }) => (
        <div className="overflow-x-auto">
          <table className="w-full border-collapse text-sm">{children}</table>
        </div>
      ),
    },
  },
};

export default function AnswerMarkdown({ text }) {
  return (
    <div className="flex flex-col gap-2 text-sm leading-relaxed text-gray-800 [&_li]:my-0.5 [&_ol]:m-0 [&_ol]:list-decimal [&_ol]:pl-5 [&_p]:m-0 [&_strong]:font-semibold [&_td]:border-0 [&_td]:border-b [&_td]:border-solid [&_td]:border-gray-100 [&_td]:py-1.5 [&_td]:pr-3 [&_th]:border-0 [&_th]:border-b [&_th]:border-solid [&_th]:border-gray-200 [&_th]:py-1.5 [&_th]:pr-3 [&_th]:text-left [&_th]:font-medium [&_ul]:m-0 [&_ul]:list-disc [&_ul]:pl-5">
      <Markdown options={OPTIONS}>{text}</Markdown>
    </div>
  );
}
